import React from 'react'
import { ImgContainer, ThankYouContainer, ThankYouText, Text, LinkTitle } from './Styles';
import Logo from '../../../../../assets/images/clinic.png';



const ThankYou = () => {

    return (
        <ThankYouContainer>
            <ImgContainer src={Logo} alt="Clinic Logo" />

            <ThankYouText>
                Thank You For Adding Clinic Profile Details!
            </ThankYouText>


        </ThankYouContainer>
    )
}

export default ThankYou
